// Rótulos em português dos valores gravados na auditoria (metadata) das mensagens da T.I.A.
export const OUTCOME_LABELS = {
  small_talk_reply: 'Saudação/agradecimento (fixa)',
  faq_reply: 'Dúvida frequente (guia)',
  blocked_reply: 'Bloqueada',
  refusal_reply: 'Recusa (tentou burlar)',
  privacy_reply: 'Dado pessoal',
  unavailable_reply: 'Seção indisponível',
  moderation_blocked: 'Bloqueada pela moderação',
  ai_reply: 'Resposta da IA',
  error: 'Erro'
};

export const INTENT_LABELS = { plataforma: 'Plataforma', suporte_tecnico: 'Suporte técnico', conteudo: 'Conteúdo' };

export const PROMPT_KIND_LABELS = { platform: 'Plataforma', content: 'Conteúdo' };

export const ROLE_LABELS = { student: 'Aluno', tia: 'T.I.A' };

export const label = (labels, key) => labels[key] ?? key;
